import { Component, ViewContainerRef } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'model-radio',
  template: `
  <div class="dynamic-field form-input form-group" [formGroup]="group">
    <label>{{map.name}}</label>
    <input type="text" [formControlName]="map.name" />
  </div>
  `,
  styles: []
})
export class RadioComponent {
    map: any;
    group: FormGroup;

}
